module.exports = __webpack_public_path__ + "static/media/IMG_1178.bc520a3b.jpg";